module.exports = __webpack_public_path__ + "static/media/care2.f0436ba1.jpg";